import { styled } from '@mui/system';

export const IconWithTextStyles = styled('div')`
    display: flex;
    gap: 10px;
    padding-bottom: 16px;
    align-items: center;

    p {
        font-size: 14px;
    }
`;
